import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Trans } from 'react-i18next';

import { QUERY_KEYS } from '@hero/constants';
import { organizationServices } from '@hero/services';
import { useNotification } from '@hero/store/hooks';
import { storage } from '@hero/utils';

export const useUpdateUser = options => {
  const queryClient = useQueryClient();
  const { showSuccess } = useNotification();

  return useMutation(body => organizationServices.updateUser(body), {
    onSuccess: response => {
      storage.setUserToken(response.token);

      if (options?.invalidate !== false) {
        queryClient.invalidateQueries([QUERY_KEYS.useGetUserKey]);

        showSuccess({
          message: <Trans i18nKey="changesSuccessfullySaved" components={{ b: <b /> }} />,
          type: 'toast'
        });
      }

      options?.onSuccess?.();
    },
    ...options
  });
};
